<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        title="抽成策略配置申请列表"
        :data="tableData"
        :columns="tableColumns"
        operateFixedType="right"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { commissionStrategy } from '@/service/apis';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { code } from '@/utils';

  export default {
    name: 'RoyaltyStrategyApplyList',
    data() {
      return {
        tableData: [],
        tableOperateButtons: [
          {
            enabled: () => code('operation:price:rake:apply:detail'),
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doDetail(row);
                  }}>
                  详情
                </ykc-button>
              );
            },
          },
          {
            enabled: () => code('operation:price:rake:apply:approve'),
            render: (h, button, { row }) => {
              if (Number(row.status) !== 1) return null;
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doApprove(row);
                  }}>
                  通过
                </ykc-button>
              );
            },
          },
          {
            enabled: () => code('operation:price:rake:apply:reject'),
            render: (h, button, { row }) => {
              if (Number(row.status) !== 1) return null;
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doReject(row);
                  }}>
                  不通过
                </ykc-button>
              );
            },
          },
          {
            enabled: () => code('operation:price:rake:apply:revoke'),
            render: (h, button, { row }) => {
              if (Number(row.status) !== 1) return null;
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doRevoke(row);
                  }}>
                  撤销
                </ykc-button>
              );
            },
          },
        ],
        tableColumns: [
          { label: '申请编码', prop: 'applyNo', minWidth: '180px' },
          { label: '电站名称', prop: 'stationName', minWidth: '200px' },
          { label: '申请提交人', prop: 'submitName', minWidth: '160px' },
          { label: '申请提交时间', prop: 'submitTime', minWidth: '180px' },
          {
            label: '状态',
            prop: 'statusDesc',
            minWidth: '120px',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row }) => row.statusDesc || '——',
            },
          },
          { label: '审核人', prop: 'auditName', minWidth: '160px' },
          { label: '审核时间', prop: 'auditTime', minWidth: '180px' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          applyNo: '',
          submitName: '',
          stationName: '',
          status: '',
        },
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'applyNo',
            label: '申请编码',
            placeholder: '请输入申请编码',
          },
          {
            comName: 'YkcInput',
            key: 'submitName',
            label: '申请提交人',
            placeholder: '请输入申请提交人',
          },
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '状态',
            placeholder: '请选择状态',
            data: [
              { id: '', name: '全部' },
              { id: 1, name: '审核中' },
              { id: 2, name: '审核通过' },
              { id: 3, name: '审核不通过' },
              { id: 4, name: '已失效' },
              { id: 5, name: '已撤销' },
            ],
          },
        ];
      },
    },
    created() {
      this.initStationName();
      this.searchTableList();
    },
    activated() {
      const { stationName } = this.$route.query;
      if (stationName !== this.searchParams.stationName) {
        this.initStationName();
        this.searchTableList();
      }
    },
    methods: {
      initStationName() {
        const { stationName } = this.$route.query;
        this.searchParams.stationName = stationName || '';
      },
      searchTableList() {
        const data = {
          ...this.searchParams,
          status: this.searchParams.status === '' ? null : this.searchParams.status,
          size: this.pageInfo.pageSize,
          current: this.pageInfo.pageIndex,
        };
        commissionStrategy.applyQueryForPage(data).then(res => {
          this.tableData = res?.records || [];
          this.pageInfo.total = res?.total || 0;
          this.pageInfo.pageIndex = res?.current || 1;
        });
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      doDetail(row) {
        this.$router.push({
          path: '/operationCenter/priceManage/royaltyStrategyApply/Detail',
          query: { applyId: row.id },
        });
      },
      doApprove(row) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认通过申请「${row.applyNo}」？通过后该电站抽成策略将立即生效。`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyApprove(row.id)
              .then(() => {
                this.$message.success('审核通过');
                done();
                this.searchTableList();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
      doReject(row) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认审核不通过申请「${row.applyNo}」？`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyReject(row.id)
              .then(() => {
                this.$message.success('已审核不通过');
                done();
                this.searchTableList();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
      doRevoke(row) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: `确认撤销申请「${row.applyNo}」？`,
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            commissionStrategy
              .applyRevoke(row.id)
              .then(() => {
                this.$message.success('已撤销');
                done();
                this.searchTableList();
              })
              .catch(() => {
                done();
              });
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
